import { Ref } from "vue";
/**
 * 1.设定dom文档
 * 2.设定监控元素
 * 3.触发active函数 */
export const useDocHeaderActive = (el: Ref<HTMLElement>) => {
    if (process.server) return;
    const activeHeader = ref("");
    const instance = getCurrentInstance();

    const visibles: { order: number; name: string }[] = reactive([]);
    // 监听回调
    const callback: IntersectionObserverCallback = (entries) => {
        entries.forEach((item) => {
            // console.log(item.target.textContent, item.intersectionRatio, visibles);
            const ele = item.target;
            // 出现到可视区
            if (item.intersectionRatio > 0) {
                visibles.push({
                    name: ele.id,
                    order: ele.dataset.order * 1,
                });
            } else {
                const index = visibles.findIndex((item) => item.name === ele.id);
                if (index > -1) visibles.splice(index, 1);
            }
        });
        // if (observer.takeRecords().length === 0) {
        //   observer.disconnect();
        //   observer = null;
        // }
    };
    const observer = new IntersectionObserver(callback, { rootMargin: "-100px" });

    watchEffect(() => {
        const current = visibles.sort((a, b) => a.order - b.order)[0];
        if (!current) return;

        activeHeader.value = current.name;
        instance?.emit("active-header", current.name);
    });

    // function emit(name: string, orderIndex?: number) {
    //     // console.log("🚀 -> file: active.core.ts:26 -> emit -> targetName", targetName);
    //     instance?.emit("active-header", targetName);
    // }

    onMounted(() => {
        const doms = getDomsQueue(el.value);

        doms.forEach((item, index) => {
            item.dataset.order = String(index);
            observer.observe(item);
        });
    });

    return activeHeader;
};

function getDomsQueue(wrapNode: HTMLElement) {
    const tags = ["h1", "h2", "h3", "h4", "h5"];

    function walkNode(wrapNodes: HTMLCollection, callback: any) {
        Array.from(wrapNodes).forEach((el) => {
            callback(el);
            walkNode(el.children, callback);
        });
    }

    const nodes: HTMLElement[] = [];
    walkNode(wrapNode.children, (el: HTMLElement) => {
        if (tags.includes(el.tagName.toLocaleLowerCase())) {
            nodes.push(el);
        }
    });

    return nodes;
}

// function useActiveHeaderWithScroller(els: HTMLElement[]) {
//     const instance = getCurrentInstance();
//     // 监听回调
//     const callback: IntersectionObserverCallback = (entries) => {
//         entries.forEach((item) => {
//             // 出现到可视区
//             if (item.intersectionRatio > 0) {
//                 const ele = item.target;
//                 emit(ele.id);
//             }
//         });
//         // if (observer.takeRecords().length === 0) {
//         //   observer.disconnect();
//         //   observer = null;
//         // }
//     };
//     const observer = new IntersectionObserver(callback);

//     function emit(targetName: string, orderIndex?: number) {
//         instance?.emit("active-header", targetName);
//     }

//     els.forEach((item) => {
//         observer.observe(item);
//     });

//     // /** 加载试图内的图片
//     //  * @params { HtmlElement } eles
//     //  * @example  <img data-src="xxx.jpg" />
//     //  */
//     // return function addEles(eles: HTMLElement[]) {
//     //     // 列表元素加入监听
//     //     eles.forEach((item) => {
//     //         observer.observe(item);
//     //     });
//     //     return observer;
//     // };
// }
